<template>
  <div class="checkBox_head checkBox_head_content">

    <!-- <el-popover placement="bottom-end" width="240" trigger="hover" popper-class="popover-vip" v-if="searchType !=6">
      <div>
        <div style="padding: 14px 12px;border-bottom: 1px solid #F2F2F2;">
          <div><b>企业权益</b></div>
          <div class="mt-10">到期时间：{{ $store.state.user.closeDate&&$store.state.user.closeDate.substring(0,10) }}</div>
        </div>
        <div style="padding: 14px 12px;">
          <p>企业权益总条数<span class="fr">{{ $store.state.user.usedTotal }} / {{ $store.state.user.total }}</span></p>
        </div>
      </div>
      <img src="~@/assets/newicons/vip.svg" slot="reference" class="img-vip" />
    </el-popover> -->

    <div class="search">
      <h1 v-if="searchTitle" style="font-weight: 500;">{{searchTitle}}</h1>

      <el-autocomplete ref="autoSelect" popper-class="recommend-head-autocomplete" :maxlength="50" :placeholder="placeholder" size="small" v-model="word" :fetch-suggestions="querySearch"
        @select="clickSearch1" @keyup.enter.native="clickSearch" @input="inputSearch">
        <a @click="clickSearch" slot="suffix" class="searchBtn">
          <div class="icon"></div>
        </a>
        <template slot-scope="{ item }">
          <div class="name" v-html="item.name"></div>
        </template>
      </el-autocomplete>

    </div>

    <dl :class="['checkBoxes',{'checkBox_head_height':!expand}]">
      <!-- <dd class="clearfix" v-if="city.list.length">
        <div class="title">{{cityTitle}}</div>
        <div :class="['selectBox','selectBox1','border_bottom',{'noheight': city.showMore}]">
          <span v-for="(c,index) in city.list" :key="index" @click="chooseCity(c, index)">{{c.name}}</span>
        </div>
        <div :class="['showMore',{'is-opened':city.showMore}]" v-show="showMoreBtn1" @click="showMore(city)"> {{!city.showMore?'更多':'收起'}}
          <i class="el-submenu__icon-arrow el-icon-arrow-down"></i>
        </div>
      </dd>
      <dd class="clearfix" v-if="industry.list.length">
        <div class="title">{{industryTitle}}</div>
        <div :class="['selectBox','selectBox2',{'noheight': industry.showMore}]">
          <span v-for="(j,index) in industry.list" :key="index" @click="chooseIndustry(j,index)">{{j.name}}</span>
        </div>
        <div :class="['showMore',{'is-opened':industry.showMore}]" v-show="showMoreBtn2" @click="showMore(industry)">{{!industry.showMore?'更多':'收起'}}
          <i class="el-submenu__icon-arrow el-icon-arrow-down"></i>
        </div>
      </dd> -->

      <!-- 时间、资本筛选 -->
      <dd class="clearfix">
        <div class="title">{{createTime.title}}</div>
        <div class="selectBox">
          <el-checkbox-group v-model="createTime.select">
            <el-checkbox v-for="(item,index) in createTime.list" :key="index" :label="item"></el-checkbox>
          </el-checkbox-group>
          <!-- 自定义
          <custom-popover :inputType="'year'" @search-handle="yearSearchHandle"></custom-popover> -->
        </div>
      </dd>
      <dd class="clearfix">
        <div class="title">{{money.title}}</div>
        <div class="selectBox">
          <el-checkbox-group v-model="money.select">
            <el-checkbox v-for="(item,index) in money.list" :key="index" :label="item"></el-checkbox>
          </el-checkbox-group>
          <!-- <custom-popover :inputType="'text'" @search-handle="moneySearchHandle"></custom-popover> -->
        </div>
      </dd>
      <!-- 号码来源 -->
      <dd class="clearfix">
        <div class="title">{{sourceValues.title}}</div>
        <div class="selectBox">
          <el-checkbox-group v-model="sourceValues.select" @change="sourceChange">
            <el-checkbox v-for="(item,index) in sourceValues.list" :key="index" :label="item"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="right-more">
          <!-- @click="sourceToggle" -->
          <div :class="['showMore',{'is-opened':souceShowMore}]">{{!souceShowMore?'更多':'收起'}}
            <i class="el-submenu__icon-arrow el-icon-arrow-down"></i>
          </div>
          <menu-common @visiableSource="visiableSource" v-if="moreShow" moreShow=true ref='conditionVal' :defaultValue="sourceValues.selectAll" :moreData="sourceValues.selectAll"
            :options='sourceOptions' type='mapped' @change='change' />
        </div>

      </dd>
      <!-- 科技型企业 -->
      <dd class="clearfix">
        <div class="title">{{tags.title}}</div>
        <div class="selectBox" style="height: 80px;">
          <el-checkbox-group v-model="tags.select" style="height: 80px;">
            <el-checkbox v-for="(item,index) in tags.list" :key="index" :label="item"></el-checkbox>
          </el-checkbox-group>
        </div>
      </dd>

      <dd class="clearfix gaojisx">
        <div class="title" style="color:rgba(255, 160, 0, 1)">高级筛选</div>
        <div class="selectBox">
          <el-dropdown trigger="click" @command="dropHandle">
            <span class="el-dropdown-link font-13">经营状态<i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,i) in screen1" :key="i" :command='item'>{{item.text}} <i class="el-icon-check" v-show="item.checked"></i></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown trigger="click" @command="dropHandle">
            <span class="el-dropdown-link font-13">人员规模<i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown" class="select-dropdown">
              <el-dropdown-item v-for="(item,i) in screen2" :key="i" :command='item'>{{item.text}} <i class="el-icon-check" v-show="item.checked"></i></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown class="select-dropdown" trigger="click" @command="dropHandle">
            <span class="el-dropdown-link font-13">企业类型<i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown" class="_auth-minh">
              <el-dropdown-item v-for="(item,i) in screen3" :key="i" :command='item'>{{item.text}} <i class="el-icon-check" v-show="item.checked"></i></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown trigger="click" @command="(item) => {dropHandle(item,5)}">
            <span class="el-dropdown-link font-13">网址信息<i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown" class="select-dropdown">
              <el-dropdown-item v-for="(item,i) in screen5" :key="i" :command='item'>{{item.text}} <i class="el-icon-check" v-show="item.checked"></i></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown trigger="click" @command="dropHandle">
            <span class="el-dropdown-link font-13">资本类型<i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown" class="select-dropdown">
              <el-dropdown-item v-for="(item,i) in screen6" :key="i" :command='item'>{{item.text}} <i class="el-icon-check" v-show="item.checked"></i></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown trigger="click" @command="(item) => {dropHandle(item, 20)}">
            <span class="el-dropdown-link font-13">网络推广<i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown" class="select-dropdown">
              <el-dropdown-item v-for="(item,i) in screen20" :key="i" :command='item'>{{item.text}} <i class="el-icon-check" v-show="item.checked"></i></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown trigger="click" @command="(item) => {dropHandle(item,7)}">
            <span class="el-dropdown-link font-13">有无手机<i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown" class="select-dropdown">
              <el-dropdown-item v-for="(item,i) in screen7" :key="i" :command='item'>{{item.text}} <i class="el-icon-check" v-show="item.checked"></i></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <template v-for="screenItem in screenList">
            <el-dropdown trigger="click" @command="(item) => {screenDropHandle(item,screenItem.value)}" :key="screenItem.value">
              <span class="el-dropdown-link font-13">有无{{screenItem.title}}<i class="el-icon-arrow-down el-icon--right"></i></span>
              <el-dropdown-menu slot="dropdown" class="select-dropdown">
                <el-dropdown-item :command='1'>有{{screenItem.title}} <i class="el-icon-check"
                    v-if="screenListValueHasKey(screenItem.value) && screenListValue[screenItem.value]==1"></i></el-dropdown-item>
                <el-dropdown-item :command='0'>无{{screenItem.title}} <i class="el-icon-check"
                    v-if="screenListValueHasKey(screenItem.value)  && screenListValue[screenItem.value]==0"></i></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <template v-if="screenItem.value == 'hasKeyContact'">
              <el-dropdown trigger="click" @command="(item) => {dropHandle(item,21)}" :key="`${screenItem.value}hasIcp`">
                <span class="el-dropdown-link font-12">有无ICP备案<i class="el-icon-arrow-down el-icon--right"></i></span>
                <el-dropdown-menu slot="dropdown" class="select-dropdown">
                  <el-dropdown-item v-for="(item,i) in screen21" :key="i" :command='item'>{{item.text}} <i class="el-icon-check" v-show="item.checked"></i></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>

        </div>
      </dd>
      <transition name="el-fade-in-linear">
        <dd v-show="selectedList.length" class="clearfix colorBg">
          <div class="title">已选条件</div>
          <div class="selectBox selectBox_noheight sub-ok-list">
            <!--  type="blue"  style="margin-right:8px"  -->
            <div class="tag-content">
              <el-tag class="tag-list" type="warning" size="medium" :key="index" v-for="(tag, index) in selectedList" closable :disable-transitions="false" @close="handleClose(tag,index)">
                {{tag.tagText || tag.text}}
              </el-tag>
            </div>
            <div class="clearAll" @click="tagClickAll">清空</div>
          </div>
        </dd>
      </transition>

    </dl>

    <div :class="{'zzhao':!expand}" @click="clickExpand"></div>
    <!-- <div class="search-save">筛选条件</div> -->
    <!-- <div class="search-save" @click="$message.warning('功能暂未开放')">筛选条件</div> -->
    <div class="search-expand-btn">
      <div class="expand toggle-btn" @click="clickExpand">
        {{expand?'收起':'展开'}}
        <i v-if="!expand" class="el-icon-arrow-down"></i>
        <i v-else class="el-icon-arrow-up"></i>
      </div>
    </div>

  </div>
</template>

<script>
import category from '@/base/category.js'
import { areaCode } from '@/base/areaCode.js'
import btnBg from '@/assets/topRightBtnbg.png'
import { selectOptions, getByName, siteSelectList } from '@/views/clue/api/newClueApi'

import { searchByCondition } from '@/views/clue/api/index.js'

const tagText = (e, label) => {
  // return { tagText: e.text == '其他' ? `${label}/其他` : e.text }
}

export default {
  name: 'searchHeadChain',
  components: {
    MenuCommon: () => import('@/views/clue/advancecomponets/children/MenuCommon.vue')
  },
  props: {
    searchType: {
      type: String,
      default: '1'
    },
    searchTitle: {
      type: String,
      default: ''
    },
    hideSome: {
      type: Boolean,
      default: false
    },
    placeholderStr: {
      type: String,
      default: null
    },
    isNewCompany: { // 是否新注册企业
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      btnBg,
      word: '',
      expand: false,
      showMoreBtn1: true,
      showMoreBtn2: true,
      category,
      areaCode,
      inquiryInput: '',
      dataPickerValue: '',
      dataPickerTime: [],
      budgetMinMoney: '1',
      budgetMaxMoney: '10',
      winTheBiddingMinMoney: '1',
      winTheBiddingMaxMoney: '10',
      city: { title: '省份地区', showMore: false, list: [], select: [] },
      industry: { title: '行业分类', showMore: false, list: [], select: [] },
      site: { title: '公司站点', showMore: false, list: [], select: [] },
      // 其他筛选
      createTime: {
        title: '成立时间',
        list: ['1个月以内', '1-12个月', '1-3年', '3-5年', '5-10年', '10年以上'],
        select: []
      },
      money: {
        title: '注册资本',
        list: ['100万以下', '100万-1000万', '1000万-1亿', '1亿-10亿', '10亿以上'],
        select: []
      },
      screen1: [{ text: '在营', checked: false }, { text: '非在营', checked: false }],
      screen2: [
        { text: '50人以内', checked: false },
        { text: '50-99人', checked: false, search: '50-99' },
        { text: '100-499人', checked: false, search: '100-499' },
        { text: '500-999人', checked: false, search: '500-999' },
        { text: '1000-4999人', checked: false, search: '1000-4999' },
        { text: '5000-9999人', checked: false, search: '5000-9999' },
        { text: '10000人以上', checked: false, search: '10000人以上' }
      ],
      screen3: [
        { text: '股份有限公司', checked: false }, { text: '有限责任公司', checked: false },
        { text: '股份合作公司', checked: false }, { text: '个体工商户', checked: false },
        { text: '农村专业合作社', checked: false }, { text: '集体所有制', checked: false },
        { text: '有限合伙', checked: false }, { text: '普通合伙', checked: false },
        { text: '联营企业', checked: false }, { text: '港、澳、台投资企业', checked: false },
        { text: '外商投资企业', checked: false }, { text: '国有企业', checked: false },
        { text: '独资企业', checked: false }, { text: '其他', checked: false }
      ],
      screen4: [
        { text: '独角兽', checked: false, search: '独角兽企业' }, { text: '瞪羚企业', checked: false, search: '瞪羚企业' },
        { text: '创新企业', checked: false, search: '技术创新示范企业' }, // { text: '规模以上', checked: false },
        { text: '高新企业', checked: false, search: '高新技术企业' }, { text: '央企', checked: false, search: '央企' },
        { text: '中国500强', checked: false, search: '中国500强' }, { text: '世界500强', checked: false, search: '世界500强' }
      ],
      screen5: [
        { text: '有网址信息', checked: false, search: 1 },
        { text: '无网址信息', checked: false, search: 0 }
      ],
      screen6: [
        { text: '人民币', checked: false },
        { text: '美元', checked: false },
        { text: '其他', checked: false }
      ],
      screen7: [
        { text: '有手机号', checked: false, search: 1 },
        { text: '无手机号', checked: false, search: 0 }
      ],
      screen8: [
        { text: '有联系电话', checked: false },
        { text: '无联系电话', checked: false }
      ],
      screen9: [
        { text: '有邮箱信息', checked: false },
        { text: '无邮箱信息', checked: false }
      ],
      screen20: [
        { text: '有网络推广信息', checked: false, search: 1 },
        { text: '无网络推广信息', checked: false, search: 0 }
      ],
      screen21: [
        { text: '有ICP备案', checked: false, search: 1 },
        { text: '无ICP备案', checked: false, search: 0 }
      ],
      // customMoney: [], // 自定义金额列表
      // customYear: [], // 自定义年份列表
      categoryId: '',
      areaCodeId: '',
      siteHistory: [],
      cityHistory: [],
      industryHistory: [], // 行业历史记录，删除时用到
      last: 1,
      carefulList: [
        { searchValue: '全部查询', field: 'word' },
        { searchValue: '招标查询', field: 'executives' },
        { searchValue: '中标查询', field: 'productName' },
        { searchValue: '拟建查询', field: 'word' }
      ],
      activeTab: 0,
      infoType: {
        title: '信息类型',
        list: ['不限', '招标公告', '中标公告', '变更公告'],
        select: '不限'
      },
      infoTypeSecond: {
        title: '公告类型:',
        list1: ['不限', '预告', '招标', '邀标', '询价', '谈判', '磋商', '单一来源', '竞价', '澄清', '审查', '终止', '其他'],
        list2: ['不限', '评价', '开标', '中标', '成交', '终止', '废标', '流标', '合同及验收', '其他'],
        list3: ['不限', '招标变更', '中标变更', '其他'],
        select: '不限'
      },
      budgetMoney: {
        title: '预算金额:',
        list: ['不限', '20万以内', '20万-50万', '50万-100万', '100万-300万', '300万以上', '自定义'],
        select: '不限'
      },
      winTheBiddingMoney: {
        title: '中标金额:',
        list: ['不限', '20万以内', '20万-50万', '50万-100万', '100万-300万', '300万以上', '自定义'],
        select: '不限'
      },
      publishTime: {
        title: '发布时间:',
        list: ['不限', '今天', '昨天', '近7天', '近1个月', '近3个月', '近1年', '自定义'],
        select: '不限'
      },
      platformFilter: {
        title: '平台筛选',
        list: ['不限', 'DY', 'KS'],
        select: '不限'
      },
      commentTime: {
        title: '评论时间',
        list: ['不限', '最近7天', '最近30天', '最近60天', '自定义时间段'],
        select: '不限'
      },
      commentGiveALikeNum: {
        title: '评论点赞数',
        list: ['不限', '0~10', '10~20', '20~30', '30以上'],
        select: '不限'
      },
      text: '',
      //  1 2 6 高级筛选 新增
      screenList: [
        {
          title: '关键人',
          value: 'hasKeyContact'
        },
        {
          title: '建站',
          value: 'hasSiteBuilder'
        },
        {
          title: '抖音店铺',
          value: 'hasDouyinShop'
        },
        {
          title: '商标',
          value: 'hasTrademark'
        },
        {
          title: '专利',
          value: 'hasPatents'
        },
        {
          title: '软件著作权',
          value: 'isMsName'
        }
      ],
      screenListValue: {},
      tags: {
        title: '科技型企业',
        list: ['高新技术企业', '科技型中小企业', '民营科技企业', '瞪羚企业', '专精特新企业', '企业技术中心', '科技小巨人企业',
          '雏鹰企业', '众创空间', '专精特新小巨人企业', '创新型中小企业', '科技企业孵化器', '技术创新示范企业', '隐形冠军企业',
          '技术先进型服务企业', '独角兽企业'],
        select: []
      },
      sourceValues: {
        title: '号码来源',
        list: ['互联网公示', '地方工商公示', '百度爱采购', '慧聪网', '盖德化工网', '谷瀑环保设备网', '世铝网', '一呼百应'],
        select: [],
        selectAll: [],
        sourceList: [
          {
            id: 606,
            label: '互联网公示',
            value: '互联网公示',
            parentId: 354
          },
          {
            id: 607,
            label: '地方工商公示',
            value: '地方工商公示',
            parentId: 354
          },
          {
            id: 601,
            label: '百度爱采购',
            value: '百度爱采购',
            parentId: 592
          },
          {
            id: 603,
            label: '慧聪网',
            value: '慧聪网',
            parentId: 592
          },
          {
            id: 258,
            label: '盖德化工网',
            value: '盖德化工网',
            parentId: 359
          },
          {
            id: 269,
            label: '谷瀑环保设备网',
            value: '谷瀑环保设备网',
            parentId: 359
          },
          {
            id: 342,
            label: '世铝网',
            value: '世铝网',
            parentId: 359
          },
          {
            id: 602,
            label: '一呼百应',
            value: '一呼百应',
            parentId: 592
          }
        ]
      },
      sourceOptions: [],
      moreShow: false,
      souceShowMore: false,
      // sourceMenuSelect: []
    }
  },
  computed: {
    placeholder() {
      return this.placeholderStr || '请输入企业名称、经营范围、地址'
    },
    selectedList: {
      get() {
        const timeArr = this.createTime.select.map((e, index) => { return { text: e, index, source: 'createTime' } })
        const moneyArr = this.money.select.map((e, index) => { return { text: e, index, source: 'money' } })
        const arr1 = this.screen1.filter(e => e.checked).map(e => { return { ...e, source: 'screen1', ...tagText(e, '经营状态') } })
        const arr2 = this.screen2.filter(e => e.checked).map(e => { return { ...e, source: 'screen2', ...tagText(e, '人员规模') } })
        const arr3 = this.screen3.filter(e => e.checked).map(e => { return { ...e, source: 'screen3', ...tagText(e, '企业类型') } })
        // const arr4 = this.screen4.filter(e => e.checked).map(e => { return { ...e, source: 'screen4', ...tagText(e, '公司实力') } })
        const arr4 = this.tags.select.map((e, index) => { return { text: e, index, source: 'tags' } })
        const arr5 = this.screen5.filter(e => e.checked).map(e => { return { ...e, source: 'screen5', ...tagText(e, '网址信息') } })
        const arr6 = this.screen6.filter(e => e.checked).map(e => { return { ...e, source: 'screen6', ...tagText(e, '资本类型') } })
        const arr7 = this.screen7.filter(e => e.checked).map(e => { return { ...e, source: 'screen7', ...tagText(e, '手机号码') } })
        const arr8 = this.screen8.filter(e => e.checked).map(e => { return { ...e, source: 'screen8', ...tagText(e, '联系电话') } })
        const arr9 = this.screen9.filter(e => e.checked).map(e => { return { ...e, source: 'screen9', ...tagText(e, '邮箱信息') } })
        const arr20 = this.screen20.filter(e => e.checked).map(e => { return { ...e, source: 'screen20', ...tagText(e, '网络推广') } })
        const arr21 = this.screen21.filter(e => e.checked).map(e => { return { ...e, source: 'screen21', ...tagText(e, 'ICP备案') } })
        // 号码来源
        const arr22 = this.sourceValues.selectAll.map(item => item.value).map((e, index) => { return { text: e, index, source: 'sourceValues' } })
        let list = [
          ...this.site.select,
          ...this.city.select,
          ...this.industry.select,
          ...timeArr,
          ...moneyArr,
          ...arr1,
          ...arr2,
          ...arr3,
          ...arr4,
          ...arr5,
          ...arr6,
          ...arr7,
          ...arr8,
          ...arr9,
          ...[{ text: this.infoType.select, type: '4' }],
          ...[{ text: this.infoTypeSecond.select, type: '5' }],
          ...[{ text: this.budgetMoney.select === '自定义' ? '预算金额' + this.budgetMinMoney + '-' + this.budgetMaxMoney + '万' : this.budgetMoney.select, type: '6' }],
          ...[{ text: this.winTheBiddingMoney.select === '自定义' ? '中标金额' + this.winTheBiddingMinMoney + '-' + this.winTheBiddingMaxMoney + '万' : this.winTheBiddingMoney.select, type: '7' }],
          ...[{ text: this.publishTime.select === '自定义' ? '发布时间-自定义' : this.publishTime.select, type: '8' }],
          ...[{ text: this.platformFilter.select, type: '9' }],
          ...[{ text: this.commentTime.select === '自定义时间段' ? '评论时间-自定义' : this.commentTime.select, type: '10' }],
          ...[{ text: this.commentGiveALikeNum.select, type: '11' }],
          ...arr20,
          ...arr21,
          ...arr22
        ]
        for (const key in this.screenListValue) {
          const txt = this.screenList.find(item => item.value === key).title
          list.push({
            text: `${this.screenListValue[key] ? '有' : '无'}${txt}`,
            checked: true,
            source: key,
            search: this.screenListValue[key]
          })

          // {text: '在营', checked: true, source: 'screen1'}
        }

        list = list.filter(x => {
          if (x.text !== '不限' && x.tagText !== '不限') {
            return true
          }
        })
        // eslint-disable-next-line vue/no-async-in-computed-properties

        this.timer && clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.$nextTick(() => {
            this.requesetChange()
          })
        }, 400)
        return list
      }
    },
    cityLv() {
      return this.cityHistory.length + 1
    },
    cityTitle() {
      let str = '省份地区'
      this.cityLv === 2 ? str = '城市' : null
      return str
    },
    industryLv() {
      return this.industryHistory.length + 1
    },
    industryTitle() {
      let str = '行业分类'
      if (this.industryLv === 2) str = '二级行业'
      if (this.industryLv === 3) str = '三级行业'
      return str
    },
    filterValue() {
      return this.$parent.filterValue
    },
    screenListValueHasKey(value) {
      return function (value) {
        return value in { ...this.screenListValue }
      }
    },
    sourceMenuSelect() {
      return this.sourceValues.select.map(item => {
        const detail = this.sourceValues.sourceList.find(detial => detial.value === item)
        return detail
      })
    }

  },
  watch: {

    searchType: {
      immediate: true,
      handler: function (val, oldVal) {
        if (val == '2') {
          this.createTime = {
            title: '成立时间',
            list: ['1个月以内', '1-12个月'],
            select: []
          }
        } else {
          this.createTime = {
            title: '成立时间',
            list: ['1个月以内', '1-12个月', '1-3年', '3-5年', '5-10年', '10年以上'],
            select: []
          }
        }
      }
    },
    'city.select.length': {
      handler(val) {
        if (!val) {
          this.cityHistory = []
          this.setCityList()
        }
      }
    },
    'industry.select.length': {
      handler(val) {
        if (!val) {
          this.industryHistory = []
          this.setIndustryList()
        }
      }
    },
    'selectedList.infoType'(val) {
      this.clearSelect()
    },
    // 搜索
    'selectedList.length'(val) {

    },
    '$route.query.word': {
      immediate: true,
      handler(val) {
        this.word = val
      }
    }

  },
  mounted() {
    this.setCityList()
    this.setIndustryList()
    if (this.searchType !== '5') {
      this.siteSelectList()
    }
    window.addEventListener('resize', this.hasShowMoreBtn)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.hasShowMoreBtn)
    })
    this.$bus.$on('deep-search', this.handleDeepSearchForBus)
    if (['1', '2', '6'].includes(this.searchType)) {
      this.selectOptions()
    }
  },
  methods: {
    tagClickAll() { // 清空所有数据
      Object.assign(this.$data, { ...this.$options.data(), word: this.$data.word })
      if (['1', '2', '6'].includes(this.searchType)) {
        this.selectOptions()
      }
      // this.$router.replace({ query: {} })
      this.$emit('clear-condition')
      this.setCityList()
      this.setIndustryList()
    },
    visiableSource(val) {
      this.souceShowMore = val
    },
    sourceChange() {
      if (this.souceShowMore) return
      const listAll = JSON.parse(JSON.stringify(this.sourceValues.selectAll))
      this.sourceValues.list.forEach(name => {
        const lisIndex = listAll.findIndex(item => item.value === name)
        if (lisIndex !== -1) listAll.splice(lisIndex, 1)
      })
      listAll.push(...this.sourceMenuSelect)

      this.sourceValues.selectAll = listAll
    },
    change(value) {
      // 条件值变化，通知条件组更新
      this.sourceValues.selectAll = JSON.parse(JSON.stringify(value))
      // this.sourceValues.select = value.map(item => item.value)
      const arr = []
      value.forEach(item => {
        if (this.sourceValues.list.includes(item.value)) {
          arr.push(item.value)
        }
      })
      this.sourceValues.select = [...arr]
    },
    async selectOptions() {
      const { data } = await selectOptions({ id: 25 })
      this.sourceOptions = data.optionVos
      this.$nextTick(() => {
        this.moreShow = true
      })
    },

    requesetChange() {
      const params = this.paramsChange()
      const newNum = []
      const obj = {
        createTime: 'estiblishTime', // 成立时间
        money: 'regCapital', // 注册资本
        screen1: 'regStatus', // 经营状态
        screen2: 'staffSize', // 人员规模
        screen3: 'companyType', // 企业规模
        // screen4: 'tags', // 实力标签
        screen5: 'website', // 站点
        screen6: 'capitalType', // 资本类型
        screen7: 'hasPhone', // 有无手机号
        screen20: 'hasPlatform', // 网络推广
        screen21: 'hasIcp', // 有无备案
        hasTrademark: 'hasTrademark', // 商标
        hasPatents: 'hasPatents', // 专利
        isMsName: 'isMsName', // 软件著作权
        hasKeyContact: 'hasKeyContact', // 关键人
        hasDouyinShop: 'hasDouyinShop', // 抖音店铺
        hasSiteBuilder: 'hasSiteBuilder', // 建站
        tags: 'tags', // 公司实力,
        sourceValues: 'sourceValues' // 号码来源
      }
      const tagsText = {
        高新企业: '高新技术企业',
        创新企业: '技术创新示范企业'
      }
      // type  1为位置信息 2为职业信息 3 为匿名公司
      this.selectedList.forEach(e => {
        if (e.type === 1) {
          if (e.lv === 1) params.province = e.text
          if (e.lv === 2) params.city = e.text
        }
        if (e.type === 2) {
          if (e.lv === 1) params.bigIndustry = e.text
          if (e.lv === 2) params.smallIndustry = e.text
        }
        if (e.source) {
          // 查询数据对应字段
          if (e.source === 'tags' && Object.keys(tagsText).includes(e.text)) e.search = tagsText[e.text]
          params[obj[e.source]].push(e.search || (e.search === 0 ? 0 : e.text))
        }

      })
      // 删除空数组
      for (const item in params) {
        if (params[item] instanceof Array) {
          if (!params[item].length) {
            delete params[item]
          }
        }
      }
      params.companyName = this.word
      this.$emit('setCondition', params)
    },
    paramsChange() {
      let params = {
        estiblishTime: [], // 成立时间
        regCapital: [], // 注册资本
        regStatus: [], // 经营状态
        staffSize: [], // 人员规模
        companyType: [] // 企业规模
        // tags: [] // 实力标签

      }
      params = {
        ...params,
        hasTrademark: [],
        hasPatents: [],
        isMsName: [],
        hasKeyContact: [],
        hasDouyinShop: [],
        hasSiteBuilder: [],
        tags: [], // 公司实力,
        sourceValues: [], // 号码来源
        website: [], // 网址信息
        capitalType: [], // 资本类型
        hasPhone: [], // 有无手机号
        hasPlatform: [], // 网络推广
        hasIcp: [] // 有无备案
      }


      return params
    },
    clickTab(item, index) {
      this.activeTab = index
      // this.getByName()
    },
    clickExpand() {
      this.expand = !this.expand
      this.$emit('clickExpand', this.expand)
    },
    handleDeepSearchForBus(keyword) {
      if (this.$route.path == '/zxk/search/clueList') {
        this.$emit('choseActiveTab', { important: true, val: 1 })
        this.word = keyword
        this.clickSearch()
      }
    },
    // handlePublishTime (val) {
    //   const res = this.publishTime.list.some(item => item === val && val === '自定义')
    //   this.definedTimeRadio = res
    //   if (res) {
    //     this.publishTime.list[this.publishTime.list.length - 1] = ''
    //   } else {
    //     this.publishTime.list[this.publishTime.list.length - 1] = '自定义'
    //   }
    // },
    async siteSelectList() {
      const { data } = await siteSelectList({})
      data.forEach(i => {
        this.site.list.push({ name: i.siteName, mainUrl: i.mainUrl })
      })
    },
    async getByName(name) {
      let res
      // 接口更改
      // res = await getByName({ name })
      const data = {
        // name: name,
        pageSize: 5,
        word: name,
        searchFlag: true,
        estiblishTime: this.isNewCompany ? ['12个月以内'] : undefined // 新企查询，默认搜索12个月以内数据
      }
      res = await searchByCondition(data)
      return res.data.items.map(e => {
        return {
          name: e.name,
          value: e.unlabeledCompanyName
        }
      })
    },
    async querySearch(queryString = '', cb) {
      if (queryString.length > 1) {
        // if (this.lastSearch !== this.word) {
        this.lastSearch = this.word
        const last = new Date().getTime()
        const res = await this.getByName(queryString)
        if (last > this.last) {
          this.lastSearchArr = res
          this.last = last
        }
        // }
        cb(this.lastSearchArr)
      } else {
        this.lastSearch = this.word
        this.lastSearchArr = []
        cb(this.lastSearchArr)
      }
    },

    hasShowMoreBtn() {
      this.$nextTick(() => {
        const r = document.querySelector('.checkBoxes')
        let rw
        if (r) {
          rw = r.offsetWidth - 240
        } else {
          return
        }
        const selectBox1 = document.querySelector('.selectBox1')

        if (selectBox1) {
          const selectBox1w = selectBox1.offsetWidth

          if (selectBox1w < rw - 200) {
            this.showMoreBtn1 = false
          }
        }
        const selectBox2 = document.querySelector('.selectBox2')
        if (selectBox2) {
          const selectBox2w = selectBox2.offsetWidth
          if (selectBox2w < rw - 200) {
            this.showMoreBtn2 = false
          }
        }
      })
    },
    /*
    * 设置城市列表 目前只有两级
    */
    setCityList() {
      this.city.list = []
      this.city.list.length = 0
      if (this.cityLv === 1) {
        areaCode.forEach(e => {
          this.city.list.push({ name: e.name, areaCodeId: e.areaCode })
        })
      } else if (this.cityLv === 2) {
        const cityObj = areaCode[this.cityHistory[this.cityHistory.length - 1]].children
        if (cityObj.length > 2) {
          cityObj.forEach(e => {
            this.city.list.push({ name: e.name, areaCodeId: e.areaCode })
          })
        }
      }
    },
    /*
    * 设置职业列表 目前2级  (之前三级)        *******************
    */
    setIndustryList() {
      this.industry.list = []
      this.industry.list.length = 0
      // 一级
      if (this.industryLv === 1) {
        this.category.forEach(e => {
          this.industry.list.push({ name: e.label, categoryId: e.value })
        })
      } else if (this.industryLv === 2) { // 三级职业逻辑跟2级一样， 全部走这里（else if 改为 else）
        let industryObj = []
        this.industryHistory.forEach((e, index) => {
          if (index === 0) {
            industryObj = this.category[e].children
          } else {
            industryObj = industryObj[e].children
          }
        })

        industryObj && industryObj.forEach(e => {
          this.industry.list.push({ name: e.label, categoryId: e.value })
        })
      }
    },
    screenDropHandle(item, value) {
      if (value in { ...this.screenListValue }) {
        this.screenListValue[value] = item
      } else this.$set(this.screenListValue, value, item)
    },

    dropHandle(item, sign) {
      if (sign === 1) {
        this.screen8.forEach(e => {
          e.checked = false
        })
      } else if (sign === 2) {
        this.screen7.forEach(e => {
          e.checked = false
        })
      } else if (sign === 3) {
        this.screen9.forEach(e => {
          e.checked = false
        })
      } else if (sign === 20) {
        this.screen20.forEach(e => {
          e.checked = false
        })
      } else if (sign === 5) {
        this.screen5.forEach(e => {
          e.checked = false
        })
      } else if (sign === 21) {
        this.screen21.forEach(e => {
          e.checked = false
        })
      } else if (sign === 7) {
        this.screen7.forEach(e => {
          e.checked = false
        })
      }

      item.checked = true
    },
    clearAllSelect() {
      this.city.select = []
      this.industry.select = []
      this.createTime.select = []
      this.money.select = []
      this.sourceValues.select = []
      this.sourceValues.selectAll = []
      this.tags.select = []
      // for (let i = 1; i < 7; i++) {
      for (let i = 1; i < 8; i++) {
        this['screen' + i].forEach(e => e.checked = false)
      }

      this.screen20.forEach(e => e.checked = false)
      this.screen21.forEach(e => e.checked = false)

      this.screenListValue = {}
    },

    handleDateTime(dataPickerTime) {
      const dateArr = []
      const dateTime = Date.parse(dataPickerTime[0])
      const dateTime1 = Date.parse(dataPickerTime[1])
      dateArr.push(dateTime, dateTime1)
    },


    // 由于后面有经营范围、产品、法人/高管、专利、地址
    clickSearch1() {
      if (this.$route.path == '/zxk/search/clueList') {
        this.$emit('choseActiveTab', { val: 0 })
      }
      this.clickSearch()
    },
    inputSearch() {
      this.requesetChange()
      // this.word = this.word && this.word.trim()
      // if (!this.word) {
      //   this.$router.replace({ query: {} })
      // }
    },
    clickSearch() {

      this.$refs.autoSelect.close()

      this.word = this.word && this.word.trim()
      if (!this.word) {
        this.$message.warning('请输入关键词！')
        return false
      }
      this.$emit('resetUnlockQ', false)
      // this.$router.replace({ query: { word: this.word } })
      let checked = false

      for (let i = 1; i < 8; i++) {
        this['screen' + i].forEach(e => {
          if (e.checked) {
            checked = true
          }
        })
      }

      this.screen20.forEach(e => {
        if (e.checked) {
          checked = true
        }
      })

      this.screen21.forEach(e => {
        if (e.checked) {
          checked = true
        }
      })

      if (this.city.select.length || this.industry.select.length ||
        this.createTime.select.length || this.money.select.length || this.sourceValues.select || this.tags.select || checked
      ) {
        this.clearAllSelect()
      } else {
        this.$emit('setCondition')
      }
    },
    showMore(item) {
      item.showMore = !item.showMore
    },

    handleClose(tag, index) {
      // 本期 高级筛选新增的
      if (tag.type === 1) {
        this.findItem(this.city.select, tag.text)
        //  this.cityHistory = this.cityHistory.reverse().splice(0,tag.lv).reverse()
        console.log(tag.lv, 9090)
        if (tag.lv === 1) {
          this.deleteAllCity()
          this.showMoreBtn1 = true
        }
        if (tag.lv === 2) {
          this.cityHistory.pop()
          this.setCityList()
        }
      } else if (tag.type === 2) {
        const len = this.industryHistory.length
        const start = tag.lv - 1
        const num = len - start
        this.industryHistory.splice(start, num)
        this.deleteNextLvIndustry()
        this.setIndustryList()
        if (tag.lv == 1) {
          this.showMoreBtn2 = true
        }
      } else if (tag.type === 3) {
        this.site.select.splice(index, 1)
      } else if (tag.source) {
        if (tag.hasOwnProperty('index')) {
          if (tag.source === 'sourceValues') {
            const indexAll = this.sourceValues.selectAll.findIndex(item => item.value === tag.text)
            if (indexAll !== -1) this.sourceValues.selectAll.splice(indexAll, 1)
            const index = this.sourceValues.select.findIndex(item => item === tag.text)
            if (index !== -1) this.sourceValues.select.splice(index, 1)
          } else { this[tag.source].select.splice(tag.index, 1) }
        } else {
          const hasKey = this.screenListValueHasKey(tag.source)
          if (hasKey) { this.$delete(this.screenListValue, tag.source) } else {
            this[tag.source].forEach(e => {
              if (e.text === tag.text) e.checked = false
            })
          }
        }
      } else if (tag.type === '4') {
        this.infoType.select = '不限'
        this.infoTypeSecond.select = '不限'
      } else {
        // eslint-disable-next-line no-unused-expressions
        tag.type === '5' ? this.infoTypeSecond.select = '不限'
          : tag.type === '6' ? this.budgetMoney.select = '不限'
            : tag.type === '7' ? this.winTheBiddingMoney.select = '不限'
              : tag.type === '8' ? this.publishTime.select = '不限'
                : tag.type === '9' ? this.platformFilter.select = '不限'
                  : tag.type === '10' ? this.commentTime.select = '不限'
                    : this.commentGiveALikeNum.select = '不限'
      }
      // this.findItem(this.createTime.select, tag)
      // this.findItem(this.money.select, tag)
      // this.findItem(this.customYear, tag)
      // this.findItem(this.customMoney, tag)
    },
    deleteAllCity() {
      this.city.select.length = 0
    },

    deleteNextLvIndustry() {
      this.industry.select = this.industry.select.filter(e => e.lv < this.industryLv)
    },
    findItem(arr, text) {
      for (let i = 0; i < arr.length; i++) {
        if ((arr[i].text || arr[i]) === text) {
          arr.splice(i, 1)
          break
        }
      }
    },
    // 选择城市
    chooseCity(c, index) {
      this.city.select.push({ type: 1, text: c.name, areaCodeId: c.areaCodeId, lv: this.cityLv })
      this.cityHistory.push(index)
      this.$nextTick(() => {
        this.setCityList()
        this.hasShowMoreBtn()
      })
    },
    // 选择职业
    chooseIndustry(i, index) {
      this.industry.select.push({ type: 2, text: i.name, categoryId: i.categoryId, lv: this.industryLv })
      this.industryHistory.push(index)
      this.$nextTick(() => {
        this.setIndustryList()
        this.hasShowMoreBtn()
      })
    },
    // 子组件调用
    setChooseSite(id, mainUrl) {
      if (this.searchType !== '5') {
        if (this.site.list.length <= 0) {
          setTimeout(() => { this.setChooseSite(id, mainUrl) }, 800)
        } else {
          this.site.list.forEach((v, index) => {
            if (v.mainUrl == mainUrl) {
              this.chooseSite(v, index)
            }
          })
        }
      }
    },

    // 选择公司站点
    chooseSite(c, index) {
      if (!this.site.select.find(e => e.text === c.name)) {
        this.site.select.push({ type: 3, text: c.name, mainUrl: c.mainUrl })
        this.siteHistory.push(index)
        this.hasShowMoreBtn()
      }
      this.requesetChange()
    },
    clearSelect() {
      this.infoTypeSecond.select = '不限'
      this.selectedList.infoTypeSecondArr = ''
    }
  },
  beforeDestroy() {
    this.$bus.$off('deep-search', this.handleDeepSearchForBus)
  }
}
</script>
<style lang="scss" scoped>
.is-radio-name {
  /deep/ .el-radio__label {
    display: none;
  }
}
.checkBox_head {
  position: relative;
  border-radius: 4px;
  box-shadow: 0px 1px 5px 0px rgba(38, 38, 38, 0.1);
  .img-vip {
    position: absolute;
    top: 25px;
    right: 39px;
    z-index: 9;
  }
  .search {
    width: 100%;
    min-width: 600px;
    height: 157px;
    // text-align: center;
    background-image: url("~@/assets/industry/header-bg.jpg");
    background-size: 100% 100%;
    // border-radius: 7px;
    position: relative;
    border-radius: 4px 4px 0 0;
    h1 {
      padding-top: 24px;
      font-size: 24px;
      font-weight: bold;
      color: #ffffff;
      line-height: 33px;
      text-align: center;
    }
    /deep/ .search-input {
      position: absolute;
      left: 50%;
      right: 0;
      margin: 0 auto;
      margin-top: 16px;
      width: 910px;
      margin-left: -455px;
      height: 44px;
      max-width: 1122px;
      input {
        height: 100%;
      }
    }
    /deep/.el-autocomplete {
      position: absolute;
      top: 73px;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 910px;
      max-width: 1122px;

      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      .el-input__inner {
        height: 44px;
        // border-radius: 0;
        padding-right: 50px;
        border: unset;
        border: none;
      }
      .el-input__suffix {
        right: 0;
      }
      .el-input__suffix .searchBtn {
        display: inline-block;
        color: #fff;
        height: 44px;
        width: 50px;
        padding: 12px;
        text-align: center;
        border: 0;
        border-radius: 0;
        .icon {
          width: 20px;
          height: 20px;
          background-image: url("~@/assets/icon/search.svg");
        }
        &:hover {
          color: #aaa;
        }
        cursor: pointer;
        i {
          margin-right: 10px;
        }
        display: inline-block;
        line-height: 44px;
        height: 100%;
        font-size: 18px;
      }
    }
    .icon {
      width: 20px;
      height: 20px;
      background-image: url("~@/assets/icon/search.svg");
    }
    /deep/ .el-input-group {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      .el-input__inner {
        height: 44px;
        border: none;
        background: #fff;
      }
      .el-input-group__append {
        border: none;
        background: #fff;
      }
    }

    .careful-search {
      display: flex;
      justify-content: space-around;
      width: 60%;
      min-width: 800px;
      position: absolute;
      left: 50%;
      top: 34%;
      transform: translate(-50%, -50%);
      .active-class {
        background: #fff;
        color: #2d6ee4;
        position: relative;
        border-radius: 4px;
        font-weight: bold;
      }
      .active-class::after {
        content: "";
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        bottom: -7px;
        border-top: solid 7px #fff;
        border-right: solid 7px transparent;
        border-left: solid 7px transparent;
      }
      span {
        cursor: pointer;
        font-size: 14px;
        color: #fff;
        padding: 3px 5px;
      }
    }
  }
  .checkBoxes {
    background-color: #fff;
    // border-radius: 7px 7px 0 0;
    padding-top: 11px;
    padding-bottom: 14px;
    padding-bottom: 0px;
    // width: calc(100% - 30px);
    margin: 0 auto;
    // margin-top: -50px;
    position: relative;
    // height: auto;
    // transition: .4s height;
    border-radius: 0 0 4px 4px;
    .colorBg {
      background-color: RGBA(249, 250, 251, 1);
      // border-top: 1px solid #f2f2f2;
    }
    dd {
      line-height: 40px;
      padding: 0 24px;
      .title {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        margin-right: 24px;
        float: left;
        min-width: 70px;
      }

      .selectBox {
        float: left;
        max-width: calc(100% - 150px);
        overflow: hidden;
        height: 40px;
        > span {
          display: inline-block;
          font-size: 13px;
          color: #333333;
          margin-right: 24px;
          cursor: pointer;
        }
        > span:hover {
          color: rgb(28, 122, 230);
        }
        /deep/ .el-dropdown {
          font-size: 13px;
          margin-right: 10px;
          cursor: pointer;
          width: 142px;
        }
        /deep/ .el-checkbox-group {
          height: 40px;
          float: left;
          .el-checkbox:hover .el-checkbox__label {
            color: rgb(28, 122, 230);
          }
          .el-checkbox__label {
            font-size: 13px;
            position: relative;
            top: -1px;
          }
        }
        /deep/ .el-checkbox {
          min-width: 142px;
          margin-right: 10px;
          &:last-child {
            margin-right: 0;
          }
        }
        .custom {
          cursor: pointer;
          margin-left: 30px;
          font-size: 12px;
        }
        /deep/ .el-tag {
          // border-color: #409eff;
          border: none;
          border-radius: 3px;
          // background: rgba(80, 136, 255, 0.2);
          // border-radius: initial;
          height: 24px;
          line-height: 24px;
          padding: 0 10px;
          // color: rgba(80, 136, 255, 1);
          font-size: 12px;
          color: #ed6826;
          margin-right: 8px;
          &.tag-list {
            margin-bottom: 8px;
            &:hover {
              color: #ed6826;
            }
          }
          i:hover {
            // background-color: rgba(80, 136, 255, 1);
          }
        }

        .budget-money-box {
          display: inline-block;

          /deep/ .el-input {
            width: 20%;
            margin: 0 3px;
          }
        }
      }

      .selectBox_noheight {
        height: auto;
      }
      .noheight {
        height: 100%;
      }
      .border_bottom {
        // border-bottom: 1px solid #f2f2f2;
      }
      .showMore {
        cursor: pointer;
        font-size: 13px;
        color: rgba(51, 51, 51, 0.5);
        float: right;
        position: relative;
        width: 42px;
        i {
          color: rgba(52, 57, 81, 0.5);
          right: 0;
        }

        &.is-opened .el-submenu__icon-arrow {
          transform: rotate(180deg);
        }
      }
      .right-more {
        float: right;
        position: relative;
      }
    }

    &.checkBox_head_height {
      height: 169px;
      overflow: hidden;
    }
  }

  .zzhao {
    height: 145px;
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    z-index: 2;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.08) 0%,
      #ffffff 100%
    );
  }
  .search-save {
    background: url("~@/assets/topRightBtnbg.png") no-repeat;
    background-size: contain;
    position: absolute;
    width: 179px;
    height: 36px;
    right: 0;
    top: 14px;
    padding: 10px 10px 10px 30px;
    color: #5088ff;
    text-align: center;
    // cursor: pointer;
  }
  .search-expand-btn {
    position: absolute;
    width: 100%;
    .expand {
      width: 78px;
      height: 20px;
      margin: 0 auto;
      line-height: 20px;
      font-size: 13px;
      text-align: center;
      background-image: url("~@/assets/newicons/search-expand-bg.png");
      background-size: 100%;
      color: #999;
      cursor: pointer;
    }
  }

  /deep/
    .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
    .el-radio__inner {
    box-shadow: none !important;
  }
}
/deep/ .el-dropdown-menu__item {
  font-size: 12px;
}
.sub-ok-list {
  display: flex;
  align-items: center;
  .tag-content {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -8px;
  }
  .clearAll {
    font-weight: 400;
    color: #5088ff;
    cursor: pointer;
    margin-left: 8px;
    white-space: nowrap;
  }
}
.gaojisx {
  line-height: 15px !important;
  padding: 18px 24px !important;
  .selectBox {
    // height: 15px !important;
    height: auto !important;
    display: flex;
    flex-wrap: wrap;
    // margin-bottom: -16px;
    .el-dropdown {
      height: 18px;
      margin-bottom: 16px;
    }
  }
}
::v-deep {
  .selectBox {
    .el-tag--medium {
      .el-icon-close {
        transform: scale(1);
      }
    }
  }
}
@media screen and (max-width: 1429px) {
  .checkBox_head .checkBoxes dd .selectBox .el-dropdown {
    margin-right: 22px;
  }
}
._auth-minh {
  min-width: 142px;
}
@media screen and (max-width: 1460px) {
  .checkBox_head_content.checkBox_head .checkBoxes dd .selectBox {
    // background: red;
    /deep/ .el-checkbox {
      min-width: 60px;
    }
  }
}
</style>
